<template>
    <div class="main-container">
        <v-container class="main-container">
            <v-row>
                <v-col class="d-flex flex-row-reverse mb-6">
                    <v-btn
                        to="/crearReceta"
                        class="ma-2 pa-2 font"
                        color="#4CABD3">
                        <v-icon
                            icon="mdi-file-document"
                            color="white"
                            class="icon"></v-icon>
                        Agregar Receta
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <EasyDataTable
                    table-class-name="customize-table"
                    buttons-pagination
                    alternating
                    :headers="headers"
                    :items="items" />
            </v-row>
        </v-container>
    </div>
</template>

<script>
import EasyDataTable from 'vue3-easy-data-table';
import { getMedRequest } from '@/api/expedientes';

export default {
    components: {
        EasyDataTable,
    },
    methods: {
        fetchMedRequest() {
            const token = localStorage.getItem('token');

            getMedRequest(token)
                .then((items) => {
                    this.items = items;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },

    mounted() {
        this.fetchMedRequest();
    },

    data() {
        return {
            headers: [
                { text: 'Id', value: 'id', sortable: true },
                { text: 'Receta', value: 'nombre', sortable: true },
                { text: 'Medicamento', value: 'apellido', sortable: true },
                { text: 'Fecha', value: 'fecha', sortable: true },
            ],
            items: [],
        };
    },
};
</script>

<style scoped>
.cabezera {
    color: white;
    /*centrar texto*/
    text-align: center;
}

.font {
    color: white;
}

.datos {
    display: flex;
}

.icon {
    align-self: Center;
    color: black;
    margin-right: 10px;
}

.table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    border-radius: 10px;
}
.customize-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    border-radius: 10px;
}
</style>
